export interface TrailCoordinate {
  latitude: number;
  longitude: number;
}

type LeafletCoordinate = [number, number];

export function splitTrailAtAntimeridian(points: TrailCoordinate[]): LeafletCoordinate[][] {
  if (points.length === 0) return [];
  const first = points[0]!;
  const segments: LeafletCoordinate[][] = [[[first.latitude, first.longitude]]];

  for (let index = 1; index < points.length; index += 1) {
    const previous = points[index - 1]!;
    const current = points[index]!;
    const segment = segments.at(-1)!;
    const difference = current.longitude - previous.longitude;

    if (Math.abs(difference) <= 180) {
      segment.push([current.latitude, current.longitude]);
      continue;
    }

    const crossingEast = difference < -180;
    const adjustedCurrent = current.longitude + (crossingEast ? 360 : -360);
    const boundary = crossingEast ? 180 : -180;
    const fraction = (boundary - previous.longitude) / (adjustedCurrent - previous.longitude);
    const crossingLatitude = previous.latitude + fraction * (current.latitude - previous.latitude);
    segment.push([crossingLatitude, boundary]);
    segments.push([
      [crossingLatitude, -boundary],
      [current.latitude, current.longitude],
    ]);
  }

  return segments;
}
